// extracted by mini-css-extract-plugin
export var emptyState = "_6e-d";
export var statCard = "_6e-c";
export var table = "_6e-0";
export var tableCell = "_6e-4";
export var tableCellClickable = "_6e-5 _6e-4";
export var tableCellDefault = "_6e-6 _6e-4";
export var tableCellEmpty = "_6e-8";
export var tableCellWithValue = "_6e-7";
export var tableContainer = "_6e-e";
export var tableHeaderWeight = "_6e-1";
export var tableHeaderZone = "_6e-2";
export var tableRowHeader = "_6e-3";
export var viewModeButton = "_6e-9";
export var viewModeButtonActive = "_6e-a _6e-9";
export var viewModeButtonInactive = "_6e-b _6e-9";